import { StudentResults } from '@yandex-int/k-common';
import cx from 'classnames';
import { Collapse } from 'education-icons';
import { Button, Modal } from 'platform-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import { LessonProblemWithResult } from 'common.components/student-lesson-stat/typings';
import { isOpenAnswer } from 'store/problems/utils';

import { useMobileCodeEditorAvailability } from 'platform-components/src/utils/hooks';
import { LessonContentAnswerControls } from '../__answer-controls/lesson-content__answer-controls';
import { LessonContentCriteriaContainer } from '../__criteria/lesson-content__criteria.container';
import { LessonContentProblemsPaginator } from '../__paginator/lesson-content__paginator';
import { LessonContentProblem } from '../__problem/lesson-content__problem';
import { lessonContentActions } from '../actions';
import { useLessonContentSelector } from '../selectors';

import './lesson-content__problem-modal.scss';

interface Props {
    problems: Array<LessonProblemWithResult>;
    studentResults: StudentResults | null;
    correctAnswersAvailable: boolean;
    studentId?: number | null;
}

// eslint-disable-next-line complexity
export const LessonContentProblemModal = ({ problems, studentResults, correctAnswersAvailable, studentId }: Props) => {
    const dispatch = useDispatch();
    const expandProblem = (problemId: number | null) => dispatch(lessonContentActions.expandProblem({ problemId }));
    const expandedProblemId = useLessonContentSelector((s) => s.expandedProblemId);
    const problemLink = problems.find((p) => p.id === expandedProblemId);
    const opened = expandedProblemId !== null;
    const openAnswer = problemLink && isOpenAnswer(problemLink.problem);

    const mobileCodeEditorIsAvailable = useMobileCodeEditorAvailability(problemLink?.problem);

    return (
        <Modal
            autoclosable={true}
            mix="lesson-content__modal"
            onRequestClose={() => dispatch(lessonContentActions.close())}
            opened={opened}
            useScale={false}
        >
            {problemLink && (
                <>
                    {!mobileCodeEditorIsAvailable && openAnswer && (
                        <LessonContentCriteriaContainer
                            problemLink={problemLink}
                            studentId={studentId}
                            studentProblemResult={studentResults?.problems[problemLink.id] || null}
                        />
                    )}
                    <LessonContentProblem
                        correctAnswersAvailable={correctAnswersAvailable}
                        itemLink={problemLink}
                        mix={cx('lesson-content__lesson-item', 'lesson-content__modal-problem')}
                    />
                </>
            )}
            <Button
                className="lesson-content__modal-close"
                icon={<Collapse />}
                onClick={() => dispatch(lessonContentActions.close())}
                rounded
                size={Button.SIZE.M}
                view={Button.VIEW.RAISED}
            />
            {!mobileCodeEditorIsAvailable && (
                <LessonContentProblemsPaginator
                    onProblemItemClick={expandProblem}
                    problems={problems}
                    selectedProblemId={expandedProblemId}
                    studentResults={studentResults}
                />
            )}
            {!mobileCodeEditorIsAvailable && correctAnswersAvailable && (
                <LessonContentAnswerControls problems={problems} studentResults={studentResults} />
            )}
        </Modal>
    );
};
